import { FC } from 'react';
import HashLink from 'components/HashLink';
import BrokerInfo, { BrokerInfoProps } from '../BrokerInfo';
import styles from './style.scss';

interface TransferFromProps {
    brokerInfo: BrokerInfoProps['data'];
    linkOptions?: {
        text: string;
        onClickLink: () => void;
    };
}

const TransferFrom: FC<TransferFromProps> = props => {
    const { linkOptions, brokerInfo } = props;
    const { onClickLink, text } = linkOptions || {};

    return (
        <div className={styles.transferFrom}>
            <div className={styles.container}>
                <div className={styles.title}>{__('Transfer From')}</div>
                {linkOptions && <HashLink onClick={onClickLink}>{text}</HashLink>}
            </div>
            <BrokerInfo data={brokerInfo} />
        </div>
    );
};

export default TransferFrom;
